import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.application_history_timeline.breadcrumb.team_timeline_label1'),
    link: '/application',
  },
  {
    label: t('pages.application_history_timeline.breadcrumb.team_timeline_label2'),
    link: '/application/history',
  },
  {
    label: t('pages.application_history_timeline.breadcrumb.team_timeline_label3'),
  },
];
